module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./favicon.ico
// module id = OU4C
// module chunks = 1